<template>
    <div v-if="isVisible">
        <div class="col-lg-12 sk-mb-30">
            <div>
                <PuSkeleton class="sk-h-250" />
            </div>
        </div>
    </div>
</template>

  
  <script>
  import Skeleton from "vue-loading-skeleton";
  
  export default {
    name: "CustomSkeleton",
    components: {
      Skeleton
    },
    props: {
      isVisible: {
        type: Boolean,
        default: true
      }
    }
  };
  </script>
  
  <style>
  /*css for skeleton*/
  .pu-skeleton {
    line-height: unset !important;
  }
  .sk-mb-30 {
    margin-bottom: 30px;
  }
  .sk-h-250 {
    height: 250px;
  }
  </style>
  



// WEBPACK FOOTER //
// src/components/MidsizeSkeleton.vue